import { render } from "./PropertiesSidebar.vue?vue&type=template&id=e6d59668&scoped=true"
import script from "./PropertiesSidebar.vue?vue&type=script&lang=js"
export * from "./PropertiesSidebar.vue?vue&type=script&lang=js"

import "./PropertiesSidebar.vue?vue&type=style&index=0&id=e6d59668&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d59668"]])

export default __exports__